import { useEffect, useRef } from 'react'
import useRoiTableStore from '@/store/roi-table'

const VisibleDateTrackerCell = ({ date, children }) => {
  const ref = useRef(null)
  const addVisibleDate = useRoiTableStore((state) => state.addVisibleDate)
  const removeVisibleDate = useRoiTableStore((state) => state.removeVisibleDate)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          addVisibleDate(date)
        } else {
          removeVisibleDate(date)
        }
      },
      {
        root: null, // 默认为浏览器视口
        rootMargin: '0px',
        threshold: 0.1, // 10% 可见时触发
      },
    )

    if (ref.current) {
      observer.observe(ref.current)
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current)
      }
      // 组件卸载时，也从 Set 中移除日期
      removeVisibleDate(date)
    }
  }, [date, addVisibleDate, removeVisibleDate])

  return <div ref={ref}>{children}</div>
}

export default VisibleDateTrackerCell
